import React, { useState } from "react";
import LoginForm from "./forms/LoginForm";
import { Link } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";

import Notification from "@/components/overlays/Notification";
import logoCYT from "/images/logo-black.png";

export default function Login() {
  const [showNotification, toggleNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <>
      <div className="flex min-h-screen">
        <div className="flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <div className="flex shrink-0 items-center px-4">
                <img className=" h-12 w-auto" src={logoCYT} alt="logo-blue" />
              </div>
            </div>

            <div className="mt-8">
              <div className="mt-6">
                <LoginForm />
              </div>

              {/* Call to Action for new users */}
              <div className="mt-8 border-t border-gray-200 pt-6">
                <div className="text-center">
                  <p className="text-sm text-gray-600 mb-4">
                    ¿No tienes una cuenta?
                  </p>

                  <Link
                    className={buttonVariants({ variant: "outline-solid" })}
                    to={`${import.meta.env.VITE_PORTAL_URL}/publica`}
                  >
                    Conoce nuestros planes
                  </Link>

                  <p className="mt-2 text-xs text-gray-500">
                    Únete en minutos y comienza a gestionar tus propiedades
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative hidden w-0 flex-1 lg:block">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src="/images/hero-casas-y-terrenos.png"
            alt=""
          />
        </div>
      </div>
      <Notification
        open={showNotification}
        setOpen={toggleNotification}
        timeOut={10000}
        type="error"
        title={errorMessage}
      />
    </>
  );
}
